"use client";

import { useConsumeReferral } from "@/hooks/useConsumeReferral";

export const ReferralConsumer = () => {
  useConsumeReferral();
  return null;
};
